module.exports = __webpack_public_path__ + "static/Gotham-BoldItalic-cbe00bccfc7a5bc9415a8b50818a2ba7.woff";